import { useProject } from '../../context/ProjectContext';
import { VISIBILITY_RANGE_OPTIONS } from '../../utils/visibility-range';
import { CalendarIcon, FilterChip, FilterMenuItem } from './FilterChip';

export function DateRangeFilter() {
  const { visibilityRange, setVisibilityRange } = useProject();

  const label =
    VISIBILITY_RANGE_OPTIONS.find((option) => option.value === visibilityRange)?.label ??
    'بازه دلخواه';
  const isActive = visibilityRange !== '30d';

  return (
    <FilterChip icon={<CalendarIcon />} label={label} active={isActive}>
      {VISIBILITY_RANGE_OPTIONS.filter((option) => option.value !== 'custom').map((option) => (
        <FilterMenuItem
          key={option.value}
          selected={visibilityRange === option.value}
          onClick={() => setVisibilityRange(option.value)}
        >
          {option.label}
        </FilterMenuItem>
      ))}
    </FilterChip>
  );
}
